export interface ServerNotification {
    id: string;
    idAlertType: number; // Int32
    alertType: string;
    alertTypeKey: string;
    description: string;
    autoResolvedDate: Date | string | null; // Nullable Date
    resolved: boolean;
    idEntity: number;
    entityName: string;
    idSystemUser: number;
    systemUser: string;
    alertTypeIcon: string;
    statusIcon: string;
    statusColor: string;
    statusBackgroundColor: string;
}

export enum ZitoneoHotelScrapingTypes {
    SCRAPING_FAILED = 'SCRAPING_FAILED',
    SCRAPING_SUCCESS = 'SCRAPING_SUCCESS',
    SCRAPING_CANCELLED = 'SCRAPING_CANCELLED',
    SCRAPING_SUCCESS_WITH_ERRORS = 'SCRAPING_SUCCESS_WITH_ERRORS',
}

export enum AlertTypeStatus {
    FAILED = 'FAILED',
    SUCCESS = 'SUCCESS',
    CANCELLED = 'CANCELLED',
    SUCCESS_WITH_ERRORS = 'SUCCESS_WITH_ERRORS',
}
